import { Tooltip } from "antd";
const AppTooltip = ({ children, ...props }) => {
    return(
        <Tooltip
            enterDelay={100}
            leaveDelay={100}
            placement='bottom'
            arrow
            overlayStyle={{ maxWidth: '200px', paddingTop: '5px'}} 
            {...props}
        >{children}</Tooltip>
    );
}

export default AppTooltip;